import ConfirmationDialog from '.'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const RebootConfirmationDialog = (props) => {
  const { t } = useTranslation()

  return (
    <ConfirmationDialog
      primaryButtonText={t('modal.reboot.primaryButton.title')}
      secondaryButtonText={t('modal.reboot.secondaryButton.title')}
      modalHeading={t('modal.reboot.heading')}
      danger={true}
      size="xs"
      {...props}
    >
      {t('modal.reboot.text')}
    </ConfirmationDialog>
  )
}
